module.exports = __webpack_public_path__ + "static/media/check-mark.223f21cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svod/appletv-icons/check-mark.svg
// module id = 636
// module chunks = 0